<template>
  <v-menu 
    :close-on-click="true" 
    :close-on-content-click="true"
    :disabled="!isLoggedIn"
    v-model="isOpen"
    offset-y
  >
    <template v-slot:activator="{ on }" >
      <v-btn 
        v-on="on"
        v-show="isLoggedIn"
        text 
        small 
      >
        <v-icon class="mr-4" dark>account_circle</v-icon>
        {{ displayname }}
      </v-btn>
    </template>

    <v-list>
      <ProfileDialog 
        :profileDetails="profileDetails"
        :closeProfileList="closeProfileList"
      />      
      <SignoutDialog 
        :SignOut="SignOut"
        :closeProfileList="closeProfileList"
      />
    </v-list>
  </v-menu>
</template>

<script>
import ProfileDialog from './ProfileDialog'
import SignoutDialog from './SignoutDialog'

export default {
  name: "ProfileListDialog",
  components: {
    ProfileDialog,
    SignoutDialog
  },
  props: [
    "profileListIsOpen",
    "profileDetails",
    "isLoggedIn",
    "displayname",
    "SignOut"
  ],
  watch: {
    isOpen(val) {
      console.log("watch: ",val)
    }
  },
  data() {
    return {
      isOpen: this.profileListIsOpen
    }
  },
  methods: {
    closeProfileList() {
      this.isOpen = false
    }
  }
}
</script>